var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPm25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.5 124.5",
    style: {
      enableBackground: "new 0 0 124.5 124.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1896C2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.3,81.3c1.2-4.3,1.4-8.5,1.4-12.8c0-19.3-10-37.3-26.8-47.3c-1.2-0.6-2.5,0-3.1,0.6 c-0.6,1.2,0,2.5,0.6,3.1c15.6,9.3,24.3,26.1,24.3,44.2c0,3.6-0.6,7.1-1.2,10.7c-0.7-0.1-1.3-0.1-2-0.1c-8.3,0-15.1,6.8-15.1,15.1 s6.8,15.1,15.1,15.1s15.1-6.8,15.1-15.1C124.5,88.8,121.2,83.8,116.3,81.3z M109.5,105.1c-5.8,0-10.5-4.7-10.5-10.5 s4.7-10.5,10.5-10.5S120,88.8,120,94.6S115.3,105.1,109.5,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.2,116.4c-6.2,2.5-13.1,3.7-19.9,3.7c-13.7,0-26.8-5.6-36.7-14.9c2.5-2.5,4.4-6.2,4.4-10.6 c0-8.1-6.8-14.9-14.9-14.9S0,85.9,0,94.6c0,8.7,6.8,14.9,14.9,14.9c2.5,0,5-0.6,7.5-1.9c10.6,10.6,24.9,16.8,39.8,16.8 c7.5,0,14.3-1.2,21.2-4.4c1.2-0.6,1.9-1.9,1.2-3.1C84,116.4,82.8,115.8,82.2,116.4z M14.7,105.1c-5.8,0-10.5-4.7-10.5-10.5 s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S20.5,105.1,14.7,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,67.2c1.2,0,2.5-0.6,2.5-1.9c1.2-21.8,16.2-39.8,36.7-46.1c1.9,6.2,7.5,10.6,14.3,10.6 c8.1,0,14.9-6.8,14.9-14.9S70.3,0,62.2,0S47.3,6.8,47.3,14.9C24.9,21.2,8.1,41.1,6.8,64.7C6.2,66,7.5,67.2,8.7,67.2z M62.2,4.5 C68,4.5,72.7,9.2,72.7,15c0,5.8-4.7,10.5-10.5,10.5S51.7,20.8,51.7,15S56.4,4.5,62.2,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,66.6l-8.1,8.8v2.8h16.2v-3.2H44.5l5.9-6.3c1.6-1.7,2.7-3.2,3.3-4.5c0.7-1.3,1-2.6,1-3.8 c0-2.1-0.7-3.7-2-4.9c-1.4-1.2-3.2-1.8-5.6-1.8c-1.6,0-3.1,0.3-4.3,1c-1.2,0.6-2.2,1.6-2.9,2.8s-1,2.5-1,4h4c0-1.4,0.4-2.5,1.1-3.3 s1.7-1.2,3-1.2c1.1,0,2,0.4,2.6,1.1c0.7,0.7,1,1.6,1,2.8c0,0.9-0.2,1.8-0.7,2.6C49.5,64.2,48.7,65.3,47.5,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,74.5c-0.4,0.4-0.6,1-0.6,1.6s0.2,1.2,0.6,1.6s1,0.6,1.7,0.6c0.8,0,1.3-0.2,1.7-0.6 c0.4-0.4,0.6-0.9,0.6-1.6c0-0.6-0.2-1.2-0.6-1.6c-0.4-0.4-1-0.6-1.7-0.6S58.5,74.1,58.1,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.2,57.4V54h-13L66,66.1l3.2,0.8c0.6-0.6,1.2-0.9,1.7-1.1c0.5-0.2,1.1-0.3,1.9-0.3c1.3,0,2.4,0.4,3.2,1.3 s1.2,2,1.2,3.5c0,1.5-0.3,2.7-1,3.6c-0.7,0.9-1.7,1.3-2.9,1.3c-1.1,0-2-0.3-2.7-0.9s-1.1-1.5-1.3-2.7h-3.9c0.1,2.1,0.9,3.7,2.4,5 c1.5,1.3,3.3,1.9,5.5,1.9c2.5,0,4.4-0.7,5.8-2.2c1.4-1.5,2.1-3.4,2.1-5.9c0-2.5-0.6-4.5-1.9-5.9s-3.1-2.2-5.4-2.2 c-1.4,0-2.7,0.3-3.8,1l0.7-5.8L80.2,57.4L80.2,57.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm25);
export default __webpack_public_path__ + "static/media/PM2.5.2d4a95440580c335efc0fdefb87f4257.svg";
export { ForwardRef as ReactComponent };